export type InternalDashboardView =
  | 'overview'
  | 'sessions'
  | 'interactions'
  | 'commerce'
  | 'spotlight'
  | 'store-detail';

export function viewToInternalPath(view: InternalDashboardView, storeSlug?: string | null): string {
  if (view === 'overview') return '/tpb-internal';
  if (view === 'store-detail' && storeSlug) return `/tpb-internal/stores/${storeSlug}`;
  return `/tpb-internal/${view}`;
}

export function internalPathToView(pathname: string): { view: InternalDashboardView; storeSlug?: string } {
  const normalized = pathname.replace(/\/$/, '');
  if (normalized.startsWith('/tpb-internal/stores/')) {
    return {
      view: 'store-detail',
      storeSlug: decodeURIComponent(normalized.slice('/tpb-internal/stores/'.length)),
    };
  }
  if (normalized === '/tpb-internal/sessions') return { view: 'sessions' };
  if (normalized === '/tpb-internal/interactions') return { view: 'interactions' };
  if (normalized === '/tpb-internal/commerce') return { view: 'commerce' };
  if (normalized === '/tpb-internal/spotlight') return { view: 'spotlight' };
  return { view: 'overview' };
}

export function normalizeInternalDashboardView(value: string | null | undefined): InternalDashboardView {
  if (
    value === 'sessions' ||
    value === 'interactions' ||
    value === 'commerce' ||
    value === 'spotlight' ||
    value === 'store-detail'
  ) {
    return value;
  }
  return 'overview';
}

export function convertInternalHref(href: string): string {
  if (href.startsWith('#')) return href;
  if (!href.startsWith('/tpb-internal')) return href;

  const [pathWithQuery = '', hash] = href.split('#');
  const [pathname = '', query = ''] = pathWithQuery.split('?');
  const params = new URLSearchParams(query);
  const { view, storeSlug } = internalPathToView(pathname);
  params.set('tab', 'internal-dashboard');
  params.set('style', 'legacy');
  params.set('view', view);
  if (storeSlug) {
    params.set('storeSlug', storeSlug);
  } else {
    params.delete('storeSlug');
  }
  const next = `/reporting?${params.toString()}`;
  return hash ? `${next}#${hash}` : next;
}

export function internalPathFromAdminSearch(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const view = normalizeInternalDashboardView(params.get('view'));
  return viewToInternalPath(view, params.get('storeSlug'));
}
